import React from 'react'
import { Box, Container } from '@mui/material'
import { Route, Routes } from 'react-router-dom'
import { NotFound } from '../routes/not-found/NotFound'
import ColumnLevel from '../routes/column-level/ColumnLevel'
import Dashboard from '../routes/dashboard/Dashboard'
import Datasets from '../routes/datasets/Datasets'
import Events from '../routes/events/Events'
import Header from './header/Header'
import Jobs from '../routes/jobs/Jobs'
import Sidenav from './sidenav/Sidenav'
import TableLevel from '../routes/table-level/TableLevel'
import Toast from './Toast'
import { useSelector } from 'react-redux'
import { IState } from '../store/reducers'
import { iframeDarkColor, iframeLightColor, HEADER_HEIGHT } from '../helpers/theme'

export default function Layout () {
  const { isIframe, theme, locale } = useSelector((state: IState) => state.iframe)

  return (
    <Box ml={isIframe ? '0px' :'80px'} sx={{ backgroundColor :theme == 'dark' ? iframeDarkColor : iframeLightColor, minHeight: `calc(100vh - ${HEADER_HEIGHT}px)`}} >
      <Sidenav />
      <Container maxWidth={'lg'} disableGutters={true}>
        <Header />
      </Container>
      <Routes key={locale}>
        <Route path={'/'} element={<Dashboard />} />
        <Route path={'/jobs'} element={<Jobs />} />
        <Route path={'/datasets'} element={<Datasets />} />
        <Route path={'/events'} element={<Events />} />
        <Route
          path={'/datasets/column-level/:namespace/:name'}
          element={<ColumnLevel />}
        />
        <Route path={'/lineage/:nodeType/:namespace/:name'} element={<TableLevel />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
      <Toast />
    </Box>
  )
}